import {useEffect, useState} from 'react'
import {Space, Table, Button, Alert, Modal, Popconfirm, Tag} from 'antd'
import {DateComponent} from '../../../components/liste/dateComponent'
import {
  DeleteOutlined,
  DislikeOutlined,
  EditOutlined,
  LikeOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import {getListeCycle, getListeCycleActive} from '../../../data/params/cycle'
import {
  addRubriqueCycle,
  deleteRubriqueCycle,
  getListeRubriqueCycle,
  updateEtatRubriqueCycle,
  updateRubriqueCycle,
} from '../../../data/params/rubriqueCycle'

const RubriqueCycle = () => {
  const [rubriques, setRubriques] = useState([])
  const [rubrique, setRubrique] = useState([])
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const [libelle, setLibelle] = useState('')
  const [cycles, setCycles] = useState([])
  const [cycle_id, setCycle_id] = useState('')
  const [description, setDescription] = useState('')
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [edite, setEdite] = useState(false)

  useEffect(() => {
    handleListeRubriqueCycle()
    handleListeCycle()
  }, [])

  const filteredItems = rubriques.filter(
    (item) =>
      item.Bog_Cycle?.libelle.toLowerCase().includes(search.toLowerCase()) ||
      item.libelle.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase()) ||
      item.id === parseInt(search)
  )

  const showModal = () => {
    setOpen(true)
  }

  const handleAddCycle = async () => {
    setLoading(true)
    const data = {cycle_id, libelle, description}
    console.log(data)
    const {status, message} = await addRubriqueCycle(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setCycle_id('')
      setDescription('')
      await handleListeRubriqueCycle()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleModifierCycle = async () => {
    setLoading(true)
    const data = {cycle_id, rubrique_id: rubrique.id, libelle, description}
    const {status, message} = await updateRubriqueCycle(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setCycle_id('')
      setDescription('')
      await handleListeRubriqueCycle()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleCancel = () => {
    setOpen(false)
    setEdite(false)
    setLibelle('')
    setCycle_id('')
    setDescription('')
    setError(false)
  }

  const selectCycle = (rubrique_id) => {
    const privil = rubriques.filter((periode) => periode.id === rubrique_id)[0]
    setRubrique(privil)
    setLibelle(privil.libelle)
    setCycle_id(privil.cycle_id)
    setDescription(privil.description)
    setEdite(true)
    setOpen(true)
  }

  const handleListeCycle = async () => {
    setLoading(true)
    const {result, status, message} = await getListeCycle()
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setCycles(result)
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }
  console.log('Cycles', cycles)

  const handleListeRubriqueCycle = async () => {
    setLoading(true)
    const {result, status, message} = await getListeRubriqueCycle()
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setRubriques(result)
      handleCancel()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleDeleteCycle = async (cycle_id) => {
    setLoading(true)
    const data = {cycle_id}
    const {status, message} = await deleteRubriqueCycle(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      await handleListeRubriqueCycle()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleUpdateEtatCycle = async (cycle_id, etat) => {
    setLoading(true)
    const data = {cycle_id, etat}
    const {status, message} = await updateEtatRubriqueCycle(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setDescription('')
      await handleListeRubriqueCycle()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const columns = [
    {
      title: '#',
      render: (text, record, index) => (
        <span className='display-block chart-blue'>{index + 1}</span>
      ),
    },
    {
      title: 'Intitule cycle',
      dataIndex: 'cycle',
      key: 'cycle_id',
      render: (_, record) => (
        <span className='display-block bold'>{record.Bog_Cycle?.libelle}</span>
      ),
    },
    {
      title: 'Libelle rubrique',
      dataIndex: 'libelle',
      key: 'libelle',
      render: (text) => <span className='display-block bold'>{text}</span>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Etat',
      dataIndex: 'etat',
      key: 'etat',
      render: (_, record) =>
        record.etat === 1 ? <Tag color='green'>Activé</Tag> : <Tag color='red'>Désactivé</Tag>,
    },
    {
      title: 'Créée le / Par',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record, index) => (
        <DateComponent
          date={record.createdAt}
          user={record.User?.nom_user + ' ' + record.User?.prenom_user}
          key={index}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Button type='primary' icon={<EditOutlined />} onClick={() => selectCycle(record.id)} />

          {record.etat === 0 && (
            <Popconfirm
              title={`Activer la période ${record.libelle} ?`}
              description={`Voulez vous vraiment activer la période ${record.libelle} ?`}
              onConfirm={() => handleUpdateEtatCycle(record.id, 1)}
              okText='Oui'
              cancelText='Non'
            >
              <Button icon={<DislikeOutlined />} className='chart-bg-orange' title='Activer ?' />
            </Popconfirm>
          )}

          {record.etat === 1 && (
            <Popconfirm
              title={`Désactiver la période ${record.libelle} ?`}
              description={`Voulez vous vraiment désactiver la période ${record.libelle} ?`}
              onConfirm={() => handleUpdateEtatCycle(record.id, 0)}
              okText='Oui'
              cancelText='Non'
            >
              <Button icon={<LikeOutlined />} className='chart-bg-green' title='Désactiver ?' />
            </Popconfirm>
          )}

          <Popconfirm
            title={`Supprimer la période ${record.libelle} ?`}
            description={`Voulez vous vraiment supprimer la période ${record.libelle} ?`}
            onConfirm={() => handleDeleteCycle(record.id)}
            okText='Oui'
            cancelText='Non'
          >
            <Button title='Supprimer ?' type='primary' icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  return (
    <>
      <div className='card mb-5 mb-lg-10'>
        {error === true && (
          <Space
            direction='vertical'
            style={{
              width: '100%',
            }}
          >
            <Alert message='Error' description={message} type='error' showIcon />
          </Space>
        )}

        <div className='card-header'>
          <div className='card-title'>
            <h3>Liste des rubriques</h3>
          </div>

          <div className='card-toolbar'>
            <div className='my-1 me-4'>
              <input
                type='text'
                name='fname'
                onChange={(e) => setSearch(e.target.value)}
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Rechercher'
              />
            </div>

            <Button type='primary' icon={<PlusOutlined />} onClick={showModal} size='large'>
              Ajouter
            </Button>
            {/* <a href="#" className="btn btn-sm btn-primary my-1">View All</a> */}
          </div>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredItems}
              pagination={{current: 1, pageSize: 50}}
            />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        title={!edite ? 'Enregistrer une nouvelle rubrique' : 'Modifier la rubrique'}
        onOk={!edite ? handleAddCycle : handleModifierCycle}
        onCancel={handleCancel}
        footer={[
          <Button key='back' onClick={handleCancel}>
            Annuler
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loading}
            onClick={!edite ? handleAddCycle : handleModifierCycle}
          >
            Enregistrer
          </Button>,
        ]}
      >
        {error === true && (
          <Space
            direction='vertical'
            style={{
              width: '100%',
            }}
          >
            <Alert message={message} type='error' showIcon />
          </Space>
        )}
        <p>
          <label className='bold'>Cycles</label>
          <select
            name='cycle_id'
            className='form-select w-100 me-15'
            onChange={(e) => {
              setCycle_id(parseInt(e.target.value))
            }}
            value={cycle_id}
          >
            <option value=''>Selectionner un cycle...</option>
            {cycles.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.libelle}
              </option>
            ))}
          </select>
        </p>
        <p>
          <label className='bold'>Libelle</label>
          <input
            type='text'
            name='fname'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            onChange={(e) => setLibelle(e.target.value)}
            value={libelle}
            placeholder='Entrez le libelle'
          />
        </p>
        <p>
          <label className='bold'>Description</label>
          <input
            type='text'
            name='fname'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            placeholder='Entrez la description'
          />
        </p>
      </Modal>
    </>
  )
}

export default RubriqueCycle
